import api from '../utils/api';

const NotificationService = {
  getNotifications: async () => {
    try {
      const response = await api.get('/api/notifications', { skipCache: true });
      return response.data;
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.message?.includes('CORS')) return [];
      
      return [];
    }
  },

  getUnreadCount: async () => {
    try {
      const response = await api.get('/api/notifications/unread', { skipCache: true });
      return response.data.count;
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.message?.includes('CORS')) return 0;
      
      return 0;
    }
  },

  markAsRead: async (notificationId) => {
    try {
      const response = await api.put(`/api/notifications/${notificationId}/read`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  markAllAsRead: async () => {
    try {
      const response = await api.put('/api/notifications/read-all');
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  deleteNotification: async (notificationId) => {
    try {
      const response = await api.delete(`/api/notifications/${notificationId}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  clearAllNotifications: async () => {
    try {
      const response = await api.delete('/api/notifications/clear-all');
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  createNotification: async (notificationData) => {
    try {
      const response = await api.post('/api/notifications', notificationData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  setChallengeReminder: async (challenge) => {
    try {
      if (!challenge) throw new Error('Invalid challenge: challenge object is null or undefined');
      if (!challenge.startDate) throw new Error('Invalid challenge data: missing startDate');

      const startDate = new Date(challenge.startDate);
      if (isNaN(startDate.getTime())) throw new Error('Invalid challenge data: startDate is not a valid date');

      const challengeId = challenge._id || challenge.id;
      if (!challengeId) throw new Error('Invalid challenge data: missing ID');
      
      // Call the new reminder endpoint
      const response = await api.post('/api/notifications/challenge-reminder', { challengeId });
      return response.data;
    } catch (error) {
      
      throw error;
    }
  }
};

export default NotificationService;